// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"445":"420cfa6e","499":"4bae2ec3","644":"31a52c89","826":"86c7d309"}[chunkId] + ".chunk.css";
};